import React, { useState, useEffect, useRef } from "react";
import {
  getQuiz,
  updateQuizActivity,
  getQuizActivity,
  getChallengeInfo,
  createNewChallenge,
  addQuizOptionSelection,
  getQuizStats,
  userTakenChallengeForSkill,
} from "../../../redux/actions/quiz";
import {
  addChallengeToStore,
  editLastVisitedContent,
  editRedirectType,
  enrollSkill,
} from "../../../redux/actions/userActivity";
import { getUserActivity } from "../../../redux/actions/userActivity";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleLeft,
  faAngleRight,
  faTimes,
  faCoins,
  faUnlock,
  faTriangleExclamation,
} from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import QuizScoreCard from "../QuizScoreCard";
import Spinner from "../../../components/Spinner";
import { addUserActivity } from "../../../redux/actions/profileDetails";
import {
  getLessonFeedBack,
  getMskillProgress,
  markLessonAsWatched,
  setActivationPhase,
  setQuizTrackAttempt,
} from "../../../redux/actions/contentPayer";
import {
  discountActivity,
  leadScoringActivity,
  userActivity,
} from "../../../common/constants";
import { useNavigate, useParams } from "react-router-dom";
import { Mixpanel } from "../../../config/Mixpanel";
import Constants from "../../../common/constants";
// import { useConfetti } from '../../../hooks/useConfetti';
// import { classNames } from '../../../utils/classNames';
import { options } from "./constants";
// import ProgressSteps from './ProgressSteps';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import CircularSpinner from "../../../components/CircularSpinner";
import { Timer } from "./Timer";
import QuizPopup from "../CelebrationPopups.jsx/QuizPopup";
import { IKImage } from "imagekitio-react";
import Progressbar from "../../../components/Progressbar";
import MskillComplete from "./MskillComplete";
import OneDayChallenge from "./oneDayChallenge";
import { getDiscountByActivity } from "../../../redux/actions/userActivity";
import ReportQuizModal from "./ReportQuizModal";
import { createLeadScore } from "../../../redux/actions/pricing";
import {
  getJESProjection,
  updateJesScore,
} from "../../../redux/actions/jobEligibilityScore";
import {
  SET_IS_ACTIVATION,
  SET_LAST_MSKILL_COMPLETED,
} from "../../../redux/actions/types";
import ProgressBar from "./ProgressBar";
import OneDayTimer from "./oneDayTimer";
import ActivationModal from "./ActivationModal";
import ContentCreator from "../ContentCreator";
import { perksSection } from "../../../redux/actions/skills";
import useWindowSize from "../../../hooks/useWindowSize";
import "./index.css";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { ENV, LINKEDIN_REDIRECT_URI } from "../../../config/api_config";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
);

const Quiz = ({
  lessonId,
  setProgress,
  setWatchedLessons,
  mSkillProgress,
  ToggleBtn,
  isUserEnrolled,
  mainRef,
  mskillData,
  skillProgress,
  setDiscountForLessonAndComplete,
  discountForLessonAndComplete,
  oneDayScrollRef,
  quizRef,
  quizActivity,
  mskillProgressObject,
  setmSKillProgressObject,
}) => {
  // const { lessonId } = useParams()
  const betaProductUser = useSelector(
    (store) => store?.personaliseCourse?.betaUsers,
  );
  const [quiz, setQuiz] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [questionAnswer, setQuestionAnswer] = useState([
    { selectedOption: "", isCorrect: false, isAnswered: false },
  ]);
  const [showScore, setShowScore] = useState(false);
  const [spinner, setSpinner] = useState(true);
  const [isQuizSubmitted, setIsQuizSubmitted] = useState(false);

  const [challengeModal, setChallengeModal] = useState(false);
  const [challengePopover, setChallengePopover] = useState(false);
  const [userAlreadyTakenChallenge, setUserAlreadyTakenChallenge] =
    useState(false);
  const currentSubscription = useSelector((store) =>
    store?.userSubscription?.role_type
      ? store?.userSubscription?.role_type
      : "basic",
  );
  const is_activation = useSelector(
    (store) => store?.userActivity?.is_activation,
  );
  // const [submitButtonRef, confetti] = useConfetti();
  const [showQuizPoll, setShowQuizPoll] = useState(false);
  const [quizPoll, setQuizPoll] = useState(null);
  const timerRef = useRef(null);
  // const countRef = useRef(0);
  const navigate = useNavigate();
  const { course_slug, skill_slug, mskill_slug } = useParams();
  const dispatch = useDispatch();
  const userId = useSelector((state) => state?.profileDetails?.id);
  const user_role = useSelector((store) => store?.userSubscription?.user_role);
  const user_token = useSelector((store) => store?.authentication?.user_token);
  const email = useSelector((store) => store?.profileDetails?.email);
  const [challengeSpinner, setChallengSpinner] = useState(false);
  const [quizAttempt, setQuizAttempt] = useState([]);
  const [revisitQuiz, setRevisitQuiz] = useState(false);
  const [feedbackData, setFeedbackData] = useState({});
  const [revisitFeedBackData, setRevisitFeedbackData] = useState({});
  const [generateFeedBack, setGenerateFeedBack] = useState(false);
  const [nextLesson, setNextLesson] = useState({
    isNextLessonAvailable: false,
    nextLessonDetails: "",
  });
  const [isFirstTimeUser, setIsFirstTimeUser] = useState(null);
  const [nextLessonTimer, setNextLessonTimer] = useState({
    enable: false,
    timer: !isFirstTimeUser ? 10 : 5,
  });
  const [quizNotification, setQuizNotification] = useState(true);

  const [successPopup, setSuccessPopup] = useState(false);
  const [enableQuizAutoNext, setEnableQuizautoNext] = useState(false);
  const [enableMskillAutoNext, setEnableMskillAutoNext] = useState(true);
  const [quizReportModal, setQuizReportModal] = useState(false);
  const [jesData, setJesData] = useState(null);
  const [challengeInfo, setChallengeInfo] = useState([]);
  const [isLastLesson, setIsLastLessson] = useState(false);
  const [oneDayChallengeActivity, setOneDayChallengeActivity] = useState(false);
  //const [mskillProgressObject , setmSKillProgressObject] = useState();
  const [activationModal, setActivationModal] = useState(false);
  const { width } = useWindowSize();
  const first_name = useSelector((store) => store?.profileDetails?.first_name);
  const [showMore, setShowMore] = useState(false);
  const handlePrevChange = () => {
    timerRef.current && clearTimeout(timerRef.current);
    setEnableQuizautoNext(false);

    if (currentIndex !== 0) {
      setCurrentIndex(currentIndex - 1);
      setShowQuizPoll(false);
      setQuizPoll(null);
    }
  };

  useEffect(() => {
    dispatch(
      getJESProjection(userId, mskill_slug, (successObj) =>
        setJesData(successObj),
      ),
    );
  }, []);

  console.log("isQuizSubmitted", isQuizSubmitted, quizActivity);

  const handleNextChange = () => {
    timerRef.current && clearTimeout(timerRef.current);
    setEnableQuizautoNext(false);
    if (currentIndex !== quiz.length - 1) {
      if (!questionAnswer[currentIndex + 1]) {
        setQuestionAnswer([
          ...questionAnswer,
          { selectedOption: "", isCorrect: false, isAnswered: false },
        ]);
      }

      setCurrentIndex(currentIndex + 1);
      setShowQuizPoll(false);
      setQuizPoll(null);
    }
  };

  useEffect(() => {
    let timer;
    // if (nextLessonTimer.timer < 0) {
    //   clearInterval(timer)
    // }
    if (
      nextLessonTimer.enable &&
      nextLessonTimer.timer > 0 &&
      enableMskillAutoNext
    ) {
      timer = setInterval(() => {
        setNextLessonTimer((prev) => ({
          ...prev,
          timer: nextLessonTimer.timer - 1,
        }));
      }, 1000);
    }

    if (
      (user_role == 4 || user_role == 6) &&
      !generateFeedBack &&
      nextLessonTimer.timer === 0 &&
      mSkillProgress < 100 &&
      userAlreadyTakenChallenge
    ) {
      navigate(`/${nextLesson?.nextLessonDetails}`);
    }
    return () => {
      clearInterval(timer);
    };
  }, [
    nextLessonTimer.enable,
    nextLessonTimer.timer,
    generateFeedBack,
    userAlreadyTakenChallenge,
    enableMskillAutoNext,
  ]);

  useEffect(() => {
    setShowMore(false);
    const currentmskill = mskillData?.find(
      (item) => item.mskill_slug === mskill_slug,
    );
    console.log("testing yes/no", currentmskill, mskillData, lessonId);
    if (
      currentmskill?.lessons_of_mskill?.[
        currentmskill?.lessons_of_mskill?.length - 1
      ]?.id === lessonId
    ) {
      setIsLastLessson(true);
      console.log("testing yes", currentmskill);
    } else {
      setIsLastLessson(false);
      console.log("testing no", currentmskill);
    }
    const currentLessonIndex = currentmskill?.lessons_of_mskill?.findIndex(
      (item) => item?.id === lessonId,
    );
    if (currentLessonIndex === currentmskill?.lessons_of_mskill?.length - 1) {
      if (
        mskillData?.findIndex((item) => item?.mskill_slug === mskill_slug) ===
        mskillData?.length - 1
      ) {
        setNextLesson((prev) => ({ ...prev, isNextLessonAvailable: false }));
      } else {
        let nextIncompleteLesson = currentmskill?.lessons_of_mskill?.find(
          (item) => item?.completed === false,
        );
        setNextLesson((prev) => ({
          ...prev,
          isNextLessonAvailable: true,
          nextLessonDetails: `${nextIncompleteLesson?.course_slug}/${nextIncompleteLesson?.skill_slug}/${nextIncompleteLesson?.mskill_slug}/${nextIncompleteLesson?.id}`,
        }));
      }
    } else {
      let nextLesson =
        currentmskill?.lessons_of_mskill[
          currentmskill?.lessons_of_mskill.findIndex(
            (item) => item?.id === lessonId,
          ) + 1
        ];
      setNextLesson((prev) => ({
        ...prev,
        isNextLessonAvailable: true,
        nextLessonDetails: `${nextLesson?.course_slug}/${nextLesson?.skill_slug}/${nextLesson?.mskill_slug}/${nextLesson?.id}`,
      }));
    }

    if (mSkillProgress === 100) {
      setNextLessonTimer((prev) => ({
        ...prev,
        enable: false,
        timer: !isFirstTimeUser ? 10 : 5,
      }));
    } else {
      setNextLessonTimer((prev) => ({
        ...prev,
        enable: isQuizSubmitted,
        timer: !isFirstTimeUser ? 10 : 5,
      }));
    }
  }, [isQuizSubmitted, lessonId, mskill_slug, mskillData]);

  useEffect(() => {
    dispatch(
      userTakenChallengeForSkill(skill_slug, userId, (successObj) => {
        setUserAlreadyTakenChallenge(successObj?.challenge_already_taken);
      }),
    );
  }, [skill_slug]);

  useEffect(() => {
    if (mSkillProgress === 100) {
      setNextLessonTimer((prev) => ({
        ...prev,
        enable: false,
        timer: !isFirstTimeUser ? 10 : 5,
      }));
    }
  }, [mSkillProgress]);

  useEffect(() => {
    if (currentIndex !== 0) {
      dispatch(
        setQuizTrackAttempt(
          quiz?.[currentIndex - 1]?.id,
          quizAttempt?.[currentIndex - 1],
        ),
      );
    }
  }, [currentIndex]);

  useEffect(() => {
    setRevisitQuiz(false);
    if (user_token) {
      console.log(
        "This is quiz activity changed 2",
        quizActivity,
        lessonId,
        quizActivity?.filter((item) => item?.lesson_id === lessonId),
      );
      console.log(quizActivity?.filter((item) => item?.lesson_id === lessonId));
      const isCompleted = quizActivity?.filter(
        (item) => item?.lesson_id === lessonId,
      )?.[0]?.completed;
      console.log("This is completed", isCompleted);
      if (isCompleted) {
        setIsQuizSubmitted(true);
        setRevisitQuiz(true);
        setEnableMskillAutoNext(false);
        setSpinner(false);
      } else {
        dispatch(
          getQuiz(lessonId, (res) => {
            setQuiz(res);
            setSpinner(false);
          }),
        );
      }
    }
  }, [lessonId, quizActivity]);

  console.log("revisit", { revisitQuiz }, { isQuizSubmitted });
  useEffect(() => {
    setChallengSpinner(false);
    setFeedbackData({});
    setQuizAttempt([]);
    if (user_token) {
      setIsFirstTimeUser(localStorage?.getItem("is_feedback"));
      setOneDayChallengeActivity(false);
      dispatch(
        getLessonFeedBack(lessonId, quizAttempt, "en", false, (successObj) => {
          setRevisitFeedbackData(successObj);
        }),
      );
      dispatch(
        getChallengeInfo(userId, mskill_slug, (successObj) => {
          setChallengeInfo(successObj);

          if (successObj.length > 0) {
            if (!userAlreadyTakenChallenge) {
              if (successObj?.[0]?.["3day_challenge"] === "declined") {
                setChallengeModal(true);
                setChallengePopover(false);
              } else {
                setChallengeModal(false);
                setChallengePopover(true);
              }
            } else {
              setChallengeModal(true);
              setChallengePopover(false);
            }
          }
        }),
      );
    } else {
      dispatch(
        getQuiz(lessonId, (res) => {
          setQuiz(res);
          setSpinner(false);
        }),
      );
    }
    setQuizPoll(null);
    setShowQuizPoll(false);
    return () => {
      setSpinner(true);
      setCurrentIndex(0);
      setQuestionAnswer([
        { selectedOption: "", isCorrect: false, isAnswered: false },
      ]);
      setShowScore(false);
      setIsQuizSubmitted(false);
      setEnableMskillAutoNext(true);
      timerRef.current && clearInterval(timerRef.current);
    };
  }, [lessonId]);

  useEffect(() => {
    setChallengeModal(false);
  }, [mskill_slug]);
  console.log("hh", quizAttempt);
  useEffect(async () => {
    if (user_token) {
      // if (!questionAnswer[currentIndex].isAnswered) {
      setEnableQuizautoNext(true);
      if (questionAnswer[currentIndex].selectedOption) {
        const currentQuizId = quiz?.[currentIndex]?.id;

        const findAttemptQuiz = quizAttempt?.findIndex(
          (item) => item?.quiz_id === currentQuizId,
        );
        console.log("hh", findAttemptQuiz);
        if (findAttemptQuiz === -1) {
          setQuizAttempt((prev) => [
            ...prev,
            {
              quiz_id: currentQuizId,
              quiz_attempt_object: [
                {
                  attempt_number: 1,
                  selected_option:
                    questionAnswer[currentIndex]?.selectedOptionIndex,
                },
              ],
            },
          ]);
        } else {
          const newAttemptData = [...quizAttempt];
          newAttemptData[findAttemptQuiz].quiz_attempt_object.push({
            attempt_number:
              newAttemptData[findAttemptQuiz].quiz_attempt_object.length + 1,
            selected_option: questionAnswer[currentIndex]?.selectedOptionIndex,
          });
          setQuizAttempt(newAttemptData);
        }
        const questionAnswerObj = {
          ...questionAnswer[currentIndex],
          isAnswered: true,
        };
        const newQuestionAnswer = [...questionAnswer];
        newQuestionAnswer[currentIndex] = questionAnswerObj;
        setQuestionAnswer(newQuestionAnswer);
        await dispatch(
          addQuizOptionSelection(
            quiz[currentIndex].id,
            getQuizOption(questionAnswer[currentIndex].selectedOption),
          ),
        );
        await dispatch(
          getQuizStats(quiz[currentIndex].id, (res) => {
            setQuizPoll(res);
          }),
        );
        Mixpanel.track(Constants.Mixpanel.QUIZ_ATTEMPT, {
          distinct_id: email,
        });
      } else {
        // if(is_activation){
        //  // console.log('reaching there')
        //   toast.error('Select an option first before trying',{
        //   position: 'bottom-right',
        //   autoClose: 2000,
        //   hideProgressBar: false,
        //   closeOnClick: true,
        //   pauseOnHover: true,
        //   draggable: true,
        //   progress: undefined,
        //   })
        //   return;
        // }
        // toast.warn('Please select an option', {
        //   position: 'top-right',
        //   autoClose: 2000,
        //   hideProgressBar: false,
        //   closeOnClick: true,
        //   pauseOnHover: true,
        //   draggable: true,
        //   progress: undefined,
        // });
      }
    } else {
      if (questionAnswer[currentIndex].selectedOption) navigate("/login");
    }
  }, [questionAnswer[currentIndex].selectedOption]);

  console.log("answer", questionAnswer);
  const handleInputChange = async (e, index) => {
    //console.log('clicked', index );
    if (!questionAnswer[currentIndex].isCorrect) {
      const selectedAnswer = e.target.value;
      const questionAnswerObj = {
        ...questionAnswer[currentIndex],
        selectedOption: selectedAnswer,
        selectedOptionIndex: String.fromCharCode(index + 65),
      };
      const newQuestionAnswer = [...questionAnswer];
      newQuestionAnswer[currentIndex] = questionAnswerObj;
      setQuestionAnswer(newQuestionAnswer);
    }
    // const currentQuizId = quiz?.[currentIndex]?.id;
    //   console.log('selection' , currentQuizId);

    //if(quizAttempt.filter())
    //handleSubmit();
    //questionAnswer[currentIndex].isCorrect ? handleNextChange() : handleSubmit();

    // * auto enroll user to mskill

    if (!isUserEnrolled) {
      await dispatch(enrollSkill(skill_slug, mskill_slug, userId));
      // dispatch(
      //   addUserActivity(userId, userActivity.COURSE_ENROLLED, '', false, skill_slug)
      // );
      await dispatch(getUserActivity(userId));
    }
  };

  useEffect(() => {
    if (
      questionAnswer[currentIndex].isAnswered &&
      questionAnswer[currentIndex]?.selectedOption.trim().toLowerCase() ===
        quiz[currentIndex]["quiz_correctAnswer"].trim().toLowerCase()
    ) {
      const questionAnswerObj = {
        ...questionAnswer[currentIndex],
        isCorrect: true,
      };
      const newQuestionAnswer = [...questionAnswer];
      newQuestionAnswer[currentIndex] = questionAnswerObj;
      setQuestionAnswer(newQuestionAnswer);
    } else {
      const questionAnswerObj = {
        ...questionAnswer[currentIndex],
        isCorrect: false,
      };
      const newQuestionAnswer = [...questionAnswer];
      newQuestionAnswer[currentIndex] = questionAnswerObj;
      setQuestionAnswer(newQuestionAnswer);
    }
  }, [questionAnswer[currentIndex]?.isAnswered]);

  useEffect(() => {
    if (
      questionAnswer[currentIndex].selectedOption !== "" &&
      questionAnswer[currentIndex].isAnswered &&
      !questionAnswer[currentIndex].isCorrect
    ) {
      const questionAnswerObj = {
        ...questionAnswer[currentIndex],
        isAnswered: false,
      };
      const newQuestionAnswer = [...questionAnswer];
      newQuestionAnswer[currentIndex] = questionAnswerObj;
      setQuestionAnswer(newQuestionAnswer);
    }
  }, [questionAnswer[currentIndex]?.selectedOption]);

  useEffect(() => {
    // Update quiz activity when all questions are answered
    if (
      questionAnswer.length === quiz.length &&
      questionAnswer.every((question) => question.isCorrect)
    ) {
      /* Confetti Explode */
      localStorage?.setItem("is_feedback", "false");
      dispatch(
        setQuizTrackAttempt(
          quiz?.[currentIndex - 1]?.id,
          quizAttempt?.[currentIndex - 1],
        ),
      );
      if (
        quizAttempt?.[0]?.quiz_attempt_object?.length === 1 &&
        quizAttempt?.[1]?.quiz_attempt_object?.length === 1 &&
        quizAttempt?.[2]?.quiz_attempt_object?.length === 1
      ) {
        //do nothing
      } else {
        !(user_role == 4 || user_role == 6) &&
          dispatch(
            getLessonFeedBack(
              lessonId,
              quizAttempt,
              "en",
              quizAttempt?.length > 0 ? true : false,
              (successObj) => {
                setFeedbackData(successObj);
                setQuizAttempt([]);
              },
            ),
          );
      }
      setmSKillProgressObject((prev) => ({
        ...prev,
        progress_by_completed: {
          ...prev?.progress_by_completed,
          completedLessons: prev?.progress_by_completed?.completedLessons + 1,
        },
      }));
      // confetti();
      if (!challengeModal) {
        setChallengePopover(true);
      }
      dispatch(
        updateQuizActivity(
          userId,
          lessonId,
          (res) => {
            if (res.completed) {
              setWatchedLessons((prev) => [...prev, res]);
              setProgress(res.mskill_progress);

              dispatch(
                markLessonAsWatched(userId, res.lesson_id, (successObj) => {
                  dispatch(
                    addUserActivity(
                      userId,
                      userActivity.LESSON_WATCHED,
                      "",
                      false,
                    ),
                  );
                }),
              );

              dispatch(
                addUserActivity(
                  userId,
                  userActivity.LESSON_COMPLETED,
                  "",
                  false,
                  null,
                  async (successObj) => {
                    let discountByLesson = null;
                    let discountByCompleted = null;
                    let discountBytwoMskill = null;
                    let discountBythreeMskill = null;

                    await dispatch(
                      getDiscountByActivity(
                        userId,
                        discountActivity.COMPLETED_TWO_LESSONS_IN_SKILL.type,
                        (successObj) => {
                          discountByLesson = successObj;
                        },
                      ),
                    );

                    await dispatch(
                      getDiscountByActivity(
                        userId,
                        discountActivity.MSKILL_COMPLETED.type,
                        (successObj) => {
                          discountByCompleted = successObj;
                        },
                      ),
                    );

                    await dispatch(
                      getDiscountByActivity(
                        userId,
                        discountActivity.COMPLETED_TWO_MSKILL.type,
                        (successObj) => {
                          discountBytwoMskill = successObj;
                        },
                      ),
                    );

                    await dispatch(
                      getDiscountByActivity(
                        userId,
                        discountActivity.COMPLETED_THREE_MSKILL.type,
                        (successObj) => {
                          discountBythreeMskill = successObj;
                        },
                      ),
                    );

                    //console.log("hi", discountByCompleted, discountByLesson, discountBytwoMskill, discountBythreeMskill)

                    if (
                      discountByCompleted === null &&
                      discountByLesson === null &&
                      discountBytwoMskill === null &&
                      discountBythreeMskill === null
                    ) {
                      // do nothing
                    } else {
                      if (
                        discountByLesson === null &&
                        discountByCompleted !== null &&
                        discountBytwoMskill === null &&
                        discountBythreeMskill === null
                      ) {
                        setDiscountForLessonAndComplete((prev) => ({
                          ...prev,
                          open: true,
                          data: discountByCompleted,
                          modalType: discountActivity.MSKILL_COMPLETED,
                        }));
                      } else if (
                        discountByLesson !== null &&
                        discountByCompleted === null &&
                        discountBytwoMskill === null &&
                        discountBythreeMskill == null
                      ) {
                        setDiscountForLessonAndComplete((prev) => ({
                          ...prev,
                          open: true,
                          data: discountByLesson,
                          modalType:
                            discountActivity.COMPLETED_TWO_LESSONS_IN_SKILL,
                        }));
                      } else if (
                        discountByLesson === null &&
                        discountByCompleted === null &&
                        discountBytwoMskill !== null &&
                        discountBythreeMskill === null
                      ) {
                        setDiscountForLessonAndComplete((prev) => ({
                          ...prev,
                          open: true,
                          data: discountBytwoMskill,
                          modalType: discountActivity.COMPLETED_TWO_MSKILL,
                        }));
                      } else if (
                        discountByLesson === null &&
                        discountByCompleted === null &&
                        discountBytwoMskill === null &&
                        discountBythreeMskill !== null
                      ) {
                        setDiscountForLessonAndComplete((prev) => ({
                          ...prev,
                          open: true,
                          data: discountBythreeMskill,
                          modalType: discountActivity.COMPLETED_THREE_MSKILL,
                        }));
                      } else if (
                        discountByLesson?.discount >
                        discountByCompleted?.discount
                      ) {
                        setDiscountForLessonAndComplete((prev) => ({
                          ...prev,
                          open: true,
                          data: discountByLesson,
                          modalType:
                            discountActivity.COMPLETED_TWO_LESSONS_IN_SKILL,
                        }));
                      } else {
                        setDiscountForLessonAndComplete((prev) => ({
                          ...prev,
                          open: true,
                          data: discountByCompleted,
                          modalType: discountActivity.MSKILL_COMPLETED,
                        }));
                      }
                    }
                  },
                ),
              );

              dispatch(
                addUserActivity(
                  userId,
                  userActivity.QUIZ_COMPLETION,
                  "",
                  false,
                  null,
                  async (successObj) => {
                    // toast.success(
                    //   <p>
                    //     Quiz completed successfully <br /> +
                    //     {successObj.awarded_coins} coins{' '}
                    //     <FontAwesomeIcon
                    //       icon={faCoins}
                    //       className="text-yellow-400"
                    //     />
                    //   </p>
                    // );
                    // await setSuccessPopup(true)
                    await setIsQuizSubmitted(true);
                    await setEnableMskillAutoNext(true);
                    await setNextLessonTimer((prev) => ({
                      ...prev,
                      enable: true,
                    }));
                  },
                ),
              );
              if (res?.mskill_progress > 0) {
                dispatch(
                  setActivationPhase((successObj) =>
                    dispatch({ type: SET_IS_ACTIVATION, payload: false }),
                  ),
                );
              }
              if (res.mskill_progress === 100) {
                if (jesData)
                  dispatch({
                    type: SET_LAST_MSKILL_COMPLETED,
                    payload: { mskill_slug: mskill_slug, display_jes: true },
                  });
                else
                  dispatch({
                    type: SET_LAST_MSKILL_COMPLETED,
                    payload: { mskill_slug: mskill_slug, display_jes: false },
                  });

                dispatch(
                  updateJesScore(
                    userId,
                    jesData?.score_for_completion,
                    (successObj) => {
                      dispatch(
                        getJESProjection(userId, mskill_slug, (res) =>
                          setJesData(res),
                        ),
                      );
                    },
                  ),
                );
              }
              Mixpanel.track(Constants.Mixpanel.QUIZ_COMPLETE, {
                distinct_id: email,
              });
            }
          },
          (err) => {
            toast.error(err);
          },
        ),
      );
    }
    if (questionAnswer[currentIndex].isCorrect && enableQuizAutoNext) {
      timerRef.current = setTimeout(() => {
        handleNextChange();
      }, 3000);
    }
  }, [questionAnswer[currentIndex]?.isCorrect]);

  useEffect(() => {
    if (showQuizPoll && !quizPoll) {
      dispatch(
        getQuizStats(quiz[currentIndex].id, (res) => {
          setQuizPoll(res);
        }),
      );
    }
  }, [showQuizPoll]);
  //console.log(mskillProgressObject);
  useEffect(() => {
    if (showQuizPoll && quizPoll) {
      mainRef?.current.scrollTo({
        top: mainRef?.current?.scrollHeight,
        behavior: "smooth",
      });
    }
  }, [quizPoll, showQuizPoll]);

  useEffect(() => {
    if (isQuizSubmitted) {
      setEnableMskillAutoNext(false);
    }
    setFeedbackData({});
    setGenerateFeedBack(false);
  }, [lessonId]);

  const handleSubmit = async () => {
    if (user_token) {
      // if (!questionAnswer[currentIndex].isAnswered) {
      setEnableQuizautoNext(true);
      if (questionAnswer[currentIndex].selectedOption) {
        const questionAnswerObj = {
          ...questionAnswer[currentIndex],
          isAnswered: true,
        };
        const newQuestionAnswer = [...questionAnswer];
        newQuestionAnswer[currentIndex] = questionAnswerObj;
        setQuestionAnswer(newQuestionAnswer);
        await dispatch(
          addQuizOptionSelection(
            quiz[currentIndex].id,
            getQuizOption(questionAnswer[currentIndex].selectedOption),
          ),
        );
        await dispatch(
          getQuizStats(quiz[currentIndex].id, (res) => {
            setQuizPoll(res);
          }),
        );
        Mixpanel.track(Constants.Mixpanel.QUIZ_ATTEMPT, {
          distinct_id: email,
        });
      } else {
        // if(is_activation){
        //  // console.log('reaching there')
        //   toast.error('Select an option first before trying',{
        //   position: 'bottom-right',
        //   autoClose: 2000,
        //   hideProgressBar: false,
        //   closeOnClick: true,
        //   pauseOnHover: true,
        //   draggable: true,
        //   progress: undefined,
        //   })
        //   return;
        // }
        // toast.warn('Please select an option', {
        //   position: 'top-right',
        //   autoClose: 2000,
        //   hideProgressBar: false,
        //   closeOnClick: true,
        //   pauseOnHover: true,
        //   draggable: true,
        //   progress: undefined,
        // });
      }
    } else {
      navigate("/login");
    }
    // }
  };

  const handleShowScore = () => {
    setShowScore(true);
  };

  const getQuizScoreData = () => {
    let correctAnswers = 0;
    let incorrectAnswers = 0;
    let unanswered = 0;
    questionAnswer.forEach((item) => {
      if (item.isAnswered && item.selectedOption !== "") {
        if (item.isCorrect) {
          correctAnswers++;
        } else {
          incorrectAnswers++;
        }
      } else {
        unanswered++;
      }
    });
    let percentage = correctAnswers / quiz.length;
    return { correctAnswers, incorrectAnswers, unanswered, percentage };
  };

  const createChallengeHandler = async (setState) => {
    if (userId) {
      setChallengSpinner(true);

      setOneDayChallengeActivity(true);
      // console.log("hi")
      await dispatch(
        addUserActivity(
          userId,
          userActivity.CHALLENGE_ACCEPTED,
          null,
          false,
          null,
          (successObj) => {
            // console.log("hihi")
          },
        ),
      );

      await dispatch(
        createLeadScore(userId, leadScoringActivity.ACCEPTED_CHALLENGE.type),
      );

      await dispatch(
        createNewChallenge(userId, mskill_slug, async (successObj) => {
          const data = successObj;
          data.mskill_slug = mskill_slug;
          data.skill_slug = skill_slug;
          data.course_slug = course_slug;

          await dispatch(addChallengeToStore(data));
          setChallengSpinner(false);
          setChallengePopover(false);
          setChallengeModal(true);
          setUserAlreadyTakenChallenge(true);
          if (setState) {
            setState(false);
          }
          //navigate(`/${nextLesson?.nextLessonDetails}`)
        }),
      );
    } else {
      navigate("/login", {
        state: {
          from: {
            pathname: `/${course_slug}/${skill_slug}/${mskill_slug}/${lessonId}`,
          },
        },
      });
    }
  };

  const quizOptions = [
    quiz[currentIndex]?.quiz_option_1,
    quiz[currentIndex]?.quiz_option_2,
    quiz[currentIndex]?.quiz_option_3,
    quiz[currentIndex]?.quiz_option_4,
  ].filter((item) => Boolean(item));
  const getQuizOption = (selectedVal) => {
    for (let i = 0; i < quizOptions.length; i++) {
      if (quizOptions[i] === selectedVal) {
        return i + 1;
      }
    }
  };
  console.log("questionAnswer", questionAnswer);
  //console.log('nextLesson' , nextLesson);
  //Map colors based on correct choice
  const getCorrectColorCombination = () => {
    const colors = [];
    for (const option of quizOptions) {
      if (option === quiz[currentIndex]?.quiz_correctAnswer) {
        colors.push("#35CA0F");
      } else {
        colors.push("#EB1919");
      }
    }
    return colors;
  };

  const data = {
    labels: quizOptions,
    datasets: [
      {
        label: "User Poll",
        data: [
          quizPoll?.option_1,
          quizPoll?.option_2,
          quizPoll?.option_3,
          quizPoll?.option_4,
        ],
        // borderColor: 'rgb(255, 99, 132)',
        backgroundColor: getCorrectColorCombination(),
      },
    ],
  };

  function getQuizPollAnalytics(quizPoll) {
    let sum =
      quizPoll?.option_1 +
      quizPoll?.option_2 +
      quizPoll?.option_3 +
      quizPoll?.option_4;

    let pollOptions = {
      percentages: [
        (quizPoll?.option_1 * 100) / sum,
        (quizPoll?.option_2 * 100) / sum,
        (quizPoll?.option_3 * 100) / sum,
        (quizPoll?.option_4 * 100) / sum,
      ],
      colors: getCorrectColorCombination(),
    };

    return pollOptions;
  }

  function getQuizCompletedPercentage(quizAnswer) {
    let percentage = 0;
    quizAnswer.forEach((item) => {
      if (item.isCorrect) {
        percentage++;
      }
    });

    return percentage;
  }
  const [creator, setCreator] = useState([]);
  console.log("mskill", mskillProgressObject, mSkillProgress);
  useEffect(() => {
    //console.log(skill_slug);
    dispatch(
      perksSection(skill_slug, (successObj) => {
        setCreator(successObj?.course_builders);
      }),
    );
  }, []);
  // console.log(`Checking ${challengePopover} && ${userAlreadyTakenChallenge}`);
  console.log("testing", mSkillProgress, isQuizSubmitted, isLastLesson);
  console.log("revisit", revisitQuiz);
  console.log("process", ENV, LINKEDIN_REDIRECT_URI);
  async function linkedinBadgeAuth() {
    Mixpanel.track(Constants.Mixpanel.LINKEDIN_SHARE_CLICKED, {
      distinct_id: email,
    });
    try {
      dispatch(
        editRedirectType({
          type: "linkedin_content_player_badge",
          id: lessonId,
        }),
      );
      dispatch(
        editLastVisitedContent(
          `/${course_slug}/${skill_slug}/${mskill_slug}/${lessonId}`,
        ),
      );
      // dispatch(editLastUnlockedCertificateImage(sampleMskillCertificateLink))

      const client_id = "869nptcg5u1iwx";
      // console.log(client_id)
      const url = `https://www.linkedin.com/oauth/v2/authorization?client_id=${client_id}&redirect_uri=${LINKEDIN_REDIRECT_URI}&response_type=code&scope=w_member_social profile openid email`;
      window.location.href = url;
      return { success: true };
    } catch (err) {
      console.log(err);
      return { success: false };
    }
  }

  return (
    <div className="reactour-quiz quizRef w-full">
      {spinner ? (
        <Spinner className="flex h-full flex-col justify-center" />
      ) : isQuizSubmitted ? (
        mSkillProgress !== 100 || (mSkillProgress === 100 && !isLastLesson) ? (
          challengePopover && !userAlreadyTakenChallenge ? (
            <OneDayChallenge
              createChallengeHandler={createChallengeHandler}
              challengeSpinner={challengeSpinner}
              setChallengeModal={setChallengeModal}
              setChallengePopover={setChallengePopover}
              setUserAlreadyTakenChallenge={setUserAlreadyTakenChallenge}
              nextLesson={nextLesson}
              oneDayScrollRef={oneDayScrollRef}
              setOneDayChallengeActivity={setOneDayChallengeActivity}
            />
          ) : revisitQuiz ? (
            revisitFeedBackData?.result &&
            (revisitFeedBackData?.result === "failed" ? (
              <div className="m-5 flex flex-col items-center justify-center">
                <img
                  urlEndpoint="https://img.learntube.ai/public-assets/"
                  src="https://img.learntube.ai/public-assets/Content_player/graduate.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1657268054996"
                  className="mt-6 h-56 w-full md:h-56 md:w-full"
                  transformation={[
                    {
                      height: "160",
                      width: "160",
                    },
                  ]}
                />
                <h3 className="py-2 text-center text-xl font-bold md:text-2xl">
                  Congrats! You passed this quiz
                </h3>
                <div className="flex items-center justify-center">
                  <div className="text-lg font-medium">Coins Earned:</div>
                  <div className="ml-2 text-3xl font-semibold text-[#2BBD13]">
                    +1
                  </div>
                  <img
                    urlEndpoint="https://img.learntube.ai/public-assets/"
                    src={
                      "https://img.learntube.ai/public-assets/Content_player/coinImage.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1676614260936"
                    }
                    className=" ml-2 h-8 w-8"
                    transformation={[
                      {
                        height: "60",
                        width: "60",
                      },
                    ]}
                  />
                </div>
                {enableMskillAutoNext && (
                  <>
                    <div className="mt-8 mb-3 flex w-full justify-between">
                      <p className="text-md font-semibold">
                        Loading next lesson in{" "}
                        <span className="font-normal italic">
                          {nextLessonTimer.timer} sec
                        </span>
                      </p>
                      {/* <div className='flex justify-center items-center'>
              <FontAwesomeIcon icon={faCoins} className="text-amber-500 mr-2" size='lg' />
              <p className='text-[#2BBD13] text-lg font-bold'>+1</p>
            </div> */}
                    </div>
                    <Progressbar
                      progress={
                        !isFirstTimeUser
                          ? ((10 - nextLessonTimer.timer) / 10) * 100
                          : ((5 - nextLessonTimer.timer) / 5) * 100
                      }
                      progressColor={"#2BBD13"}
                    />
                  </>
                )}
                <button
                  className="mt-3 w-[199px] rounded-lg  bg-[#13B284] py-2 px-3 text-white md:w-[523px]"
                  disabled={!nextLesson?.isNextLessonAvailable}
                  onClick={() => navigate(`/${nextLesson?.nextLessonDetails}`)}
                >
                  Go To Next Lesson
                </button>
              </div>
            ) : (
              <div className="flex flex-col items-center justify-center">
                <div className="flex w-full items-center justify-between p-2">
                  <div className="text-[20px] font-semibold md:text-[32px]">
                    Feedback
                  </div>
                  <div
                    className={`box-border flex basis-auto flex-row items-center justify-center rounded-xl pl-[6.25px] pr-1.5 [background:linear-gradient(180.00deg,#1f90cf_100.00%,#84d3ff_0.00%)]`}
                  >
                    <img
                      urlEndpoint="https://img.learntube.ai/public-assets/"
                      src="https://img.learntube.ai/public-assets/Content_player/Group%209043.svg?updatedAt=1693982363150"
                      className="h-auto"
                      transformation={[
                        {
                          height: "160",
                          width: "160",
                        },
                      ]}
                    />
                    <p
                      className={`ml-[3.25px] box-border flex shrink-0 grow-0 basis-auto flex-row items-center justify-center text-[18.5px] font-semibold text-[white]`}
                    >
                      <span
                        className={`learntube-font-family text-[12px] md:text-[18.5px]`}
                      >
                        LearnTube
                      </span>
                      <span
                        className={` x-font-family mr-2 text-[12px] font-normal uppercase md:text-[18.5px]`}
                      >
                        X
                      </span>
                      <span
                        className={`learntube-font-family text-[12px] md:text-[18.5px]`}
                      >
                        {" "}
                        Feature
                      </span>
                    </p>
                  </div>
                </div>
                <div className="feedback-parent-shadow grid w-full  grid-cols-1 p-4">
                  <div className="flex w-full flex-col items-start justify-start p-1">
                    <div className="flex items-center justify-start">
                      <img
                        urlEndpoint="https://img.learntube.ai/public-assets/"
                        src="https://img.learntube.ai/public-assets/Content_player/Group%209041.svg?updatedAt=1693981585091"
                        className="mr-1 h-4 md:mr-2 md:h-auto"
                        transformation={[
                          {
                            height: "160",
                            width: "160",
                          },
                        ]}
                      />
                      <div className="text-[16px] font-semibold md:text-[20px]">
                        Your Weak Areas
                      </div>
                    </div>
                    <div className="w-full rounded-xl bg-white p-4  text-[14px] md:text-[16px] ">
                      {revisitFeedBackData?.data?.user_weak_areas?.length >
                      0 ? (
                        revisitFeedBackData?.data?.user_weak_areas
                          ?.split("\n")
                          ?.map((text, index) => (
                            <div className="mb-2 ">{text}</div>
                          ))
                      ) : (
                        <div className="w-full text-center">None for now</div>
                      )}
                    </div>
                  </div>
                  <div className="mt-4 flex w-full flex-col items-start justify-start p-1">
                    <div className="flex items-center justify-start">
                      <img
                        urlEndpoint="https://img.learntube.ai/public-assets/"
                        src="https://img.learntube.ai/public-assets/Content_player/Group%209042.svg?updatedAt=1693981584945"
                        className="mr-1 h-4 md:mr-2 md:h-auto"
                        transformation={[
                          {
                            height: "160",
                            width: "160",
                          },
                        ]}
                      />
                      <div className="text-[16px] font-semibold md:text-[20px] ">
                        Action Step
                      </div>
                    </div>
                    <div className="w-full  rounded-xl bg-white p-4 text-[14px] md:text-[16px]">
                      {revisitFeedBackData?.data?.user_action_steps?.length >
                      0 ? (
                        revisitFeedBackData?.data?.user_action_steps
                          ?.split("\n")
                          ?.map((text, index) => (
                            <div className="mb-2 ">{text}</div>
                          ))
                      ) : (
                        <div className="w-full text-center">None for now</div>
                      )}
                    </div>
                  </div>
                  <div className="mt-2 flex w-full flex-col items-center justify-center p-1 md:mt-4 ">
                    <button
                      className=" flex w-full  items-center justify-center gap-2 rounded-2xl border-2 border-[#0077B5] bg-white py-2 px-4 md:w-[30%]"
                      onClick={(e) => {
                        e.stopPropagation();
                        linkedinBadgeAuth();
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faLinkedin}
                        className="text-[#0077B5]"
                        size="2x"
                      />
                      <span className="text-[16px] font-semibold text-[#0077B5] md:text-[18px]">
                        Share On LinkedIn
                      </span>
                    </button>
                  </div>
                </div>
                <button
                  className="mt-6 w-[199px] rounded-lg  bg-[#13B284] py-2 px-3 text-white md:w-[523px]"
                  disabled={!nextLesson?.isNextLessonAvailable}
                  onClick={() => navigate(`/${nextLesson?.nextLessonDetails}`)}
                >
                  Go To Next Lesson
                </button>
                <br />
                <br />
              </div>
            ))
          ) : quizAttempt?.[0]?.quiz_attempt_object?.length === 1 &&
            quizAttempt?.[1]?.quiz_attempt_object?.length === 1 &&
            quizAttempt?.[2]?.quiz_attempt_object?.length === 1 ? (
            <div className="m-5 flex flex-col items-center justify-center">
              <img
                urlEndpoint="https://img.learntube.ai/public-assets/"
                src="https://img.learntube.ai/public-assets/Content_player/graduate.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1657268054996"
                className="mt-6 h-56 w-full md:h-56 md:w-full"
                transformation={[
                  {
                    height: "160",
                    width: "160",
                  },
                ]}
              />
              <h3 className="py-2 text-center text-xl font-bold md:text-2xl">
                Congrats! You passed this quiz
              </h3>
              <div className="flex items-center justify-center">
                <div className="text-lg font-medium">Coins Earned:</div>
                <div className="ml-2 text-3xl font-semibold text-[#2BBD13]">
                  +1
                </div>
                <img
                  urlEndpoint="https://img.learntube.ai/public-assets/"
                  src={
                    "https://img.learntube.ai/public-assets/Content_player/coinImage.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1676614260936"
                  }
                  className=" ml-2 h-8 w-8"
                  transformation={[
                    {
                      height: "60",
                      width: "60",
                    },
                  ]}
                />
              </div>
              {enableMskillAutoNext && (
                <>
                  <div className="mt-8 mb-3 flex w-full justify-between">
                    <p className="text-md font-semibold">
                      Loading next lesson in{" "}
                      <span className="font-normal italic">
                        {nextLessonTimer.timer} sec
                      </span>
                    </p>
                    {/* <div className='flex justify-center items-center'>
              <FontAwesomeIcon icon={faCoins} className="text-amber-500 mr-2" size='lg' />
              <p className='text-[#2BBD13] text-lg font-bold'>+1</p>
            </div> */}
                  </div>
                  <Progressbar
                    progress={
                      !isFirstTimeUser
                        ? ((10 - nextLessonTimer.timer) / 10) * 100
                        : ((5 - nextLessonTimer.timer) / 5) * 100
                    }
                    progressColor={"#2BBD13"}
                  />
                </>
              )}
              <button
                className="mt-3 w-[199px] rounded-lg  bg-[#13B284] py-2 px-3 text-white md:w-[523px]"
                disabled={!nextLesson?.isNextLessonAvailable}
                onClick={() => navigate(`/${nextLesson?.nextLessonDetails}`)}
              >
                Go To Next Lesson
              </button>
              <br />
              <br />
            </div>
          ) : user_role === 4 || user_role === 6 ? (
            <div className="flex w-full flex-col items-center justify-center">
              {/* changed niche wala(generateFeedBack && feedbackData?.result==="success") */}
              <div
                className={`mt-0 flex w-full flex-col items-center justify-center`}
              >
                <div className="flex w-full items-center justify-between p-2">
                  <div className="text-[20px] font-semibold md:text-[32px]">
                    Feedback
                  </div>
                  <div
                    className={`box-border flex shrink-0 grow-0 basis-auto flex-row items-center justify-center rounded-xl pl-[6.25px] pr-1.5 [background:linear-gradient(180.00deg,#1f90cf_100.00%,#84d3ff_0.00%)]`}
                  >
                    <img
                      urlEndpoint="https://img.learntube.ai/public-assets/"
                      src="https://img.learntube.ai/public-assets/Content_player/Group%209043.svg?updatedAt=1693982363150"
                      className=""
                      transformation={[
                        {
                          height: "160",
                          width: "160",
                        },
                      ]}
                    />
                    <p
                      className={`ml-[3.25px] box-border flex shrink-0 grow-0 basis-auto flex-row items-center justify-center text-[18.5px] font-semibold text-[white]`}
                    >
                      <span
                        className={`learntube-font-family text-[12px] md:text-[18.5px]`}
                      >
                        LearnTube
                      </span>
                      <span
                        className={` x-font-family mr-2 text-[12px] font-normal uppercase md:text-[18.5px]`}
                      >
                        X
                      </span>
                      <span
                        className={`learntube-font-family text-[12px] md:text-[18.5px]`}
                      >
                        {" "}
                        Feature
                      </span>
                    </p>
                  </div>
                </div>

                <div
                  className="relative flex w-full flex-col items-center justify-center overflow-hidden"
                  style={{
                    backgroundImage: `url('https://img.learntube.ai/public-assets/Ai%20notes/Rectangle%205247.png?updatedAt=1713952216423')`,
                    borderRadius: "30px",
                    width: "100%",
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                    borderRadius: "18.34px",
                    boxShadow: "0px 1.5283px 4.58491px 0px rgba(0, 0, 0, 0.25)",
                  }}
                >
                  {/* {!(generateFeedBack && feedbackData?.result==="success" && feedbackData?.data?.user_weak_areas?.length !== 0 ) && <div className='top-2 p-2 absolute blur-sm leading-snug'>Define Market Demographics: Understand basic audience characteristics like age, gender, income, occupation, etc.
Uncover Market Psychographics: Gain insights into your audience's personality, behaviors, attitudes, and preferences.
Develop Audience Persona: Use demographic and psychographic data to create a fictional representation of your target audience</div>} */}
                  {generateFeedBack === false ? (
                    <img
                      src="https://img.learntube.ai/public-assets/Content_player/Feedback%20in%20Positive%20Rating%20(1)%201.gif?updatedAt=1693985316628"
                      width={208}
                      alt="feedback placeholder"
                      height={210}
                      className="mt-6"
                    />
                  ) : !feedbackData?.result ? (
                    <img
                      src="https://img.learntube.ai/public-assets/Content_player/Idea%20creation%202.gif?updatedAt=1693985318446"
                      width={208}
                      height={210}
                      alt="feedback placeholder"
                      className="mt-6"
                    />
                  ) : (
                    feedbackData?.data?.user_weak_areas?.length === 0 && (
                      <div className="flex w-full flex-col items-center justify-center">
                        <div className="flex w-full items-center justify-center  gap-4">
                          <img
                            urlEndpoint="https://img.learntube.ai/public-assets/"
                            src="https://img.learntube.ai/public-assets/Content_player/Success%201.gif?updatedAt=1693985318834"
                            className="h-[68px] w-[68px]"
                            transformation={[
                              {
                                height: "160",
                                width: "160",
                              },
                            ]}
                          />
                          <div className="text-[14px]  md:text-[24px]">
                            Awesome! You’re In The Top{" "}
                            <span className="font-medium text-[#1F90CF]">
                              10%
                            </span>
                          </div>
                        </div>
                        {/* <div className="mt-4">
                          <div className="text-[16px] font-medium md:text-[28px]">
                            Learnings From this Lesson
                          </div>
                          <div
                            className={`mt-4 text-[14px] font-normal leading-tight text-gray-400 md:text-[18px] ${
                              showMore && "line-clamp-3"
                            }`}
                          >
                            Lorem ipsum dolor sit amet consectetur. Amet
                            consequat ut dolor quam. Ut ut eros morbi blandit
                            velit. Vel sit ridiculus lectus Lorem ipsum dolor
                            sit amet consectetur. Amet consequat ut dolor quam.
                            Ut ut eros morbi blandit velit. Vel sit ridiculus
                            lectus Lorem ipsum dolor sit amet consectetur. Amet
                            consequat ut dolor quam. Ut ut eros morbi blandit
                            velit. Vel sit ridiculus lectus{" "}
                          </div>
                          <span
                            className="mt-1 text-[14px] font-bold text-[#1295DE] underline underline-offset-2 md:text-[20px]"
                            onClick={(e) => setShowMore((prev) => !prev)}
                          >
                            Show More
                          </span>
                        </div> */}
                        <div className="mt-4 flex w-full flex-col items-center justify-center p-1 md:mt-4 ">
                          <button
                            className=" flex w-full  items-center justify-center gap-2 rounded-2xl border-2 border-[#0077B5] bg-white py-2 px-4 md:w-[30%]"
                            onClick={(e) => {
                              e.stopPropagation();
                              linkedinBadgeAuth();
                            }}
                          >
                            <FontAwesomeIcon
                              icon={faLinkedin}
                              className="text-[#0077B5]"
                              size="2x"
                            />
                            <span className="text-[16px] font-semibold text-[#0077B5] md:text-[18px]">
                              Share On LinkedIn
                            </span>
                          </button>
                        </div>
                      </div>
                    )
                  )}

                  {generateFeedBack ? (
                    feedbackData?.data?.user_weak_areas?.length !== 0 &&
                    (feedbackData?.result === "success" ? (
                      <div className="feedback-parent-shadow grid w-full grid-cols-1 p-4">
                        <div className="flex w-full flex-col items-start justify-start p-1">
                          <div className="flex items-center justify-start">
                            <img
                              urlEndpoint="https://img.learntube.ai/public-assets/"
                              src="https://img.learntube.ai/public-assets/Content_player/Group%209041.svg?updatedAt=1693981585091"
                              className="mr-1 h-4 md:mr-2 md:h-auto"
                              transformation={[
                                {
                                  height: "160",
                                  width: "160",
                                },
                              ]}
                            />
                            <div className="text-[16px] font-semibold md:text-[20px]">
                              Your Weak Areas
                            </div>
                          </div>
                          <div className="w-full rounded-xl bg-white p-4  text-[14px] md:text-[16px] ">
                            {feedbackData?.data?.user_weak_areas?.length > 0 ? (
                              feedbackData?.data?.user_weak_areas
                                ?.split("\n")
                                ?.map((text, index) => (
                                  <div className="mb-2 ">{text}</div>
                                ))
                            ) : (
                              <div className="w-full text-center">
                                None for now
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="mt-4 flex w-full flex-col items-start justify-start p-1">
                          <div className="flex items-center justify-start">
                            <img
                              urlEndpoint="https://img.learntube.ai/public-assets/"
                              src="https://img.learntube.ai/public-assets/Content_player/Group%209042.svg?updatedAt=1693981584945"
                              className="mr-1 h-4 md:mr-2 md:h-auto"
                              transformation={[
                                {
                                  height: "160",
                                  width: "160",
                                },
                              ]}
                            />
                            <div className="text-[16px] font-semibold md:text-[20px] ">
                              Action Step
                            </div>
                          </div>
                          <div className="w-full rounded-xl bg-white p-4  text-[14px] md:text-[16px]">
                            {feedbackData?.data?.user_action_steps?.length >
                            0 ? (
                              feedbackData?.data?.user_action_steps
                                ?.split("\n")
                                ?.map((text, index) => (
                                  <div className="mb-2 ">{text}</div>
                                ))
                            ) : (
                              <div className="w-full text-center">
                                None for now
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="mt-2 flex w-full flex-col items-center justify-center p-1 md:mt-4 ">
                          <button
                            className=" flex w-full  items-center justify-center gap-2 rounded-2xl border-2 border-[#0077B5] bg-white py-2 px-4 md:w-[30%]"
                            onClick={(e) => {
                              e.stopPropagation();
                              linkedinBadgeAuth();
                            }}
                          >
                            <FontAwesomeIcon
                              icon={faLinkedin}
                              className="text-[#0077B5]"
                              size="2x"
                            />
                            <span className="text-[16px] font-semibold text-[#0077B5] md:text-[18px]">
                              Share On LinkedIn
                            </span>
                          </button>
                        </div>
                      </div>
                    ) : (
                      <div className="mb-6 px-8 py-2 text-[16px] font-semibold text-black md:text-[20px]">
                        Generating Feedback For {first_name}...
                      </div>
                    ))
                  ) : (
                    <button
                      className=" upgrade-button mb-6 px-8 py-2 text-[16px] font-semibold text-white md:text-[20px]"
                      onClick={(e) => {
                        dispatch(
                          getLessonFeedBack(
                            lessonId,
                            quizAttempt,
                            "en",
                            true,
                            (successObj) => {
                              setFeedbackData(successObj);
                              setQuizAttempt([]);
                            },
                          ),
                        );
                        setGenerateFeedBack(true);
                      }}
                    >
                      Generate Feedback For {first_name}
                    </button>
                  )}
                </div>
              </div>
              {enableMskillAutoNext && !generateFeedBack && (
                <>
                  {/* changed */}
                  <div className="mt-8 mb-3 flex w-full justify-between">
                    <p className="text-[14px] md:text-[24px]">
                      Loading next lesson in{" "}
                      <span className="font-semibold">
                        {nextLessonTimer.timer}s
                      </span>
                    </p>
                    <div className="flex">
                      <img
                        urlEndpoint="https://img.learntube.ai/public-assets/"
                        src={
                          "https://img.learntube.ai/public-assets/Content_player/coinImage.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1676614260936"
                        }
                        className=" h-8 w-8"
                        transformation={[
                          {
                            height: "60",
                            width: "60",
                          },
                        ]}
                      />
                      <div className="ml-2 text-[20px] font-semibold text-[#2BBD13] md:text-3xl">
                        +1
                      </div>
                    </div>
                  </div>
                  {/* changed */}
                  <div className="w-full">
                    <Progressbar
                      progress={
                        !isFirstTimeUser
                          ? ((10 - nextLessonTimer.timer) / 10) * 100
                          : ((5 - nextLessonTimer.timer) / 5) * 100
                      }
                    />
                  </div>
                </>
              )}
              {generateFeedBack && feedbackData?.result === "success" ? (
                <button
                  className="mt-3 w-[199px] rounded-lg  bg-[#13B284] py-2 px-3 text-white md:w-[523px]"
                  disabled={!nextLesson?.isNextLessonAvailable}
                  onClick={() => navigate(`/${nextLesson?.nextLessonDetails}`)}
                >
                  Go To Next Lesson
                </button>
              ) : (
                <button
                  className="mt-3 w-[70%] rounded-lg border-2 border-[#1CA571]  bg-white py-2 px-3 text-[#1CA571] md:w-60"
                  disabled={!nextLesson?.isNextLessonAvailable}
                  onClick={() => navigate(`/${nextLesson?.nextLessonDetails}`)}
                >
                  Go To Next Lesson
                </button>
              )}
              <br />
              <br />
            </div>
          ) : (
            <div className="flex w-full flex-col items-center justify-center ">
              {/* changed niche wala feedbackData?.result === 'success' ? 'w-full' :'w-[550px]' */}
              <div
                className={`mt-0 flex w-full flex-col items-center justify-center`}
              >
                <div className="flex w-full items-center justify-between p-2">
                  <div className=" text-[20px] font-semibold  md:text-[32px]">
                    Feedback
                  </div>
                  <div
                    className={`box-border flex shrink-0 grow-0 basis-auto flex-row items-center justify-center rounded-xl pl-[6.25px] pr-1.5 [background:linear-gradient(180.00deg,#1f90cf_100.00%,#84d3ff_0.00%)]`}
                  >
                    <img
                      urlEndpoint="https://img.learntube.ai/public-assets/"
                      src="https://img.learntube.ai/public-assets/Content_player/Group%209043.svg?updatedAt=1693982363150"
                      className=""
                      transformation={[
                        {
                          height: "160",
                          width: "160",
                        },
                      ]}
                    />
                    <p
                      className={`ml-[3.25px] box-border flex shrink-0 grow-0 basis-auto flex-row items-center justify-center text-[18.5px] font-semibold text-[white]`}
                    >
                      <span
                        className={`learntube-font-family text-[12px] md:text-[18.5px]`}
                      >
                        LearnTube
                      </span>
                      <span
                        className={` x-font-family mr-2 text-[12px] font-normal uppercase md:text-[18.5px]`}
                      >
                        X
                      </span>
                      <span
                        className={`learntube-font-family text-[12px] md:text-[18.5px]`}
                      >
                        {" "}
                        Feature
                      </span>
                    </p>
                  </div>
                </div>

                {feedbackData?.result === "success" ? (
                  feedbackData?.data?.user_weak_areas?.length === 0 ? (
                    <div
                      className="mt-2 flex w-full flex-col items-center justify-center overflow-hidden p-4"
                      style={{
                        backgroundImage: `url('https://img.learntube.ai/public-assets/Ai%20notes/Rectangle%205247.png?updatedAt=1713952216423')`,
                        borderRadius: "30px",
                        width: "100%",
                        backgroundPosition: "center",
                        backgroundSize: "cover",
                        borderRadius: "18.34px",
                        boxShadow:
                          "0px 1.5283px 4.58491px 0px rgba(0, 0, 0, 0.25)",
                      }}
                    >
                      <div className="flex w-full items-center justify-center  gap-4">
                        <img
                          urlEndpoint="https://img.learntube.ai/public-assets/"
                          src="https://img.learntube.ai/public-assets/Content_player/Success%201.gif?updatedAt=1693985318834"
                          className="h-[68px] w-[68px]"
                          transformation={[
                            {
                              height: "160",
                              width: "160",
                            },
                          ]}
                        />
                        <div className="text-[14px]  md:text-[24px]">
                          Awesome! You’re In The Top{" "}
                          <span className="font-medium text-[#1F90CF]">
                            10%
                          </span>
                        </div>
                      </div>
                      {/* <div className="mt-4">
                        <div className="text-[16px] font-medium md:text-[28px]">
                          Learnings From this Lesson
                        </div>
                        <div
                          className={`mt-4 text-[14px] font-normal leading-tight text-gray-400 md:text-[18px] ${
                            showMore && "line-clamp-3"
                          }`}
                        >
                          Lorem ipsum dolor sit amet consectetur. Amet consequat
                          ut dolor quam. Ut ut eros morbi blandit velit. Vel sit
                          ridiculus lectus Lorem ipsum dolor sit amet
                          consectetur. Amet consequat ut dolor quam. Ut ut eros
                          morbi blandit velit. Vel sit ridiculus lectus Lorem
                          ipsum dolor sit amet consectetur. Amet consequat ut
                          dolor quam. Ut ut eros morbi blandit velit. Vel sit
                          ridiculus lectus{" "}
                        </div>
                        <span
                          className="mt-1 text-[14px] font-bold text-[#1295DE] underline underline-offset-2 md:text-[20px]"
                          onClick={(e) => setShowMore((prev) => !prev)}
                        >
                          Show More
                        </span>
                      </div> */}
                      <div className="mt-4 flex w-full flex-col items-center justify-center p-1 md:mt-4 ">
                        <button
                          className=" flex w-full  items-center justify-center gap-2 rounded-2xl border-2 border-[#0077B5] bg-white py-2 px-4 md:w-[30%]"
                          onClick={(e) => {
                            e.stopPropagation();
                            linkedinBadgeAuth();
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faLinkedin}
                            className="text-[#0077B5]"
                            size="2x"
                          />
                          <span className="text-[16px] font-semibold text-[#0077B5] md:text-[18px]">
                            Share On LinkedIn
                          </span>
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div className="feedback-parent-shadow grid w-full  grid-cols-1 p-4 ">
                      <div className="flex w-full flex-col items-start justify-start p-1">
                        <div className="flex items-center justify-start">
                          <img
                            urlEndpoint="https://img.learntube.ai/public-assets/"
                            src="https://img.learntube.ai/public-assets/Content_player/Group%209041.svg?updatedAt=1693981585091"
                            className="mr-1 h-4 md:mr-2 md:h-auto"
                            transformation={[
                              {
                                height: "160",
                                width: "160",
                              },
                            ]}
                          />
                          <div className="text-[16px] font-semibold md:text-[20px]">
                            Your Weak Areas
                          </div>
                        </div>
                        <div className="w-full rounded-xl bg-white p-4  text-[14px] md:text-[16px] ">
                          {feedbackData?.data?.user_weak_areas?.length > 0 ? (
                            feedbackData?.data?.user_weak_areas
                              ?.split("\n")
                              ?.map((text, index) => (
                                <div className="mb-2 ">{text}</div>
                              ))
                          ) : (
                            <div className="w-full text-center">
                              None for now
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="mt-4 flex w-full flex-col items-start justify-start p-1">
                        <div className="flex items-center justify-start">
                          <img
                            urlEndpoint="https://img.learntube.ai/public-assets/"
                            src="https://img.learntube.ai/public-assets/Content_player/Group%209042.svg?updatedAt=1693981584945"
                            className="mr-1 h-4 md:mr-2 md:h-auto"
                            transformation={[
                              {
                                height: "160",
                                width: "160",
                              },
                            ]}
                          />
                          <div className="text-[16px] font-semibold md:text-[20px] ">
                            Action Step
                          </div>
                        </div>
                        <div className="w-full rounded-xl bg-white p-4 text-[14px]  md:text-[16px]">
                          {feedbackData?.data?.user_action_steps?.length > 0 ? (
                            feedbackData?.data?.user_action_steps
                              ?.split("\n")
                              ?.map((text, index) => (
                                <div className="mb-2 ">{text}</div>
                              ))
                          ) : (
                            <div className="w-full text-center">
                              None for now
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="mt-2 flex w-full flex-col items-center justify-center p-1 md:mt-4 ">
                        <button
                          className=" flex w-full  items-center justify-center gap-2 rounded-2xl border-2 border-[#0077B5] bg-white py-2 px-4 md:w-[30%]"
                          onClick={(e) => {
                            e.stopPropagation();
                            linkedinBadgeAuth();
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faLinkedin}
                            className="text-[#0077B5]"
                            size="2x"
                          />
                          <span className="text-[16px] font-semibold text-[#0077B5] md:text-[18px]">
                            Share On LinkedIn
                          </span>
                        </button>
                      </div>
                    </div>
                  )
                ) : feedbackData?.result === "failed" ? (
                  <>
                    <div
                      className="relative  flex w-full flex-col items-center justify-start overflow-hidden p-4"
                      style={{
                        backgroundImage: `url('https://img.learntube.ai/public-assets/Ai%20notes/Rectangle%205247.png?updatedAt=1713952216423')`,
                        borderRadius: "30px",
                        width: "100%",
                        backgroundPosition: "center",
                        backgroundSize: "cover",
                        borderRadius: "18.34px",
                        boxShadow:
                          "0px 1.5283px 4.58491px 0px rgba(0, 0, 0, 0.25)",
                      }}
                    >
                      <div className="flex w-full items-center justify-center gap-4  ">
                        <img
                          urlEndpoint="https://img.learntube.ai/public-assets/"
                          src="https://img.learntube.ai/public-assets/Content_player/dizziness%201.gif?updatedAt=1693985316179"
                          className="h-[72px] w-[43px]"
                          transformation={[
                            {
                              height: "160",
                              width: "160",
                            },
                          ]}
                        />
                        <div className="text-start text-[14px] font-normal md:text-[24px]">
                          You’ve Exhausted All Your{" "}
                          <span className="text-[#FF2633]">3</span> Feedbacks
                          For Today.
                        </div>
                      </div>
                      {/* <div className="mt-4">
                          <div className="text-[16px] font-medium md:text-[28px]">
                            Learnings From this Lesson
                          </div>
                          <div
                            className={`mt-4 text-[14px] font-normal leading-tight text-gray-400 md:text-[18px] ${
                              showMore && "line-clamp-3"
                            }`}
                          >
                            Lorem ipsum dolor sit amet consectetur. Amet
                            consequat ut dolor quam. Ut ut eros morbi blandit
                            velit. Vel sit ridiculus lectus Lorem ipsum dolor
                            sit amet consectetur. Amet consequat ut dolor quam.
                            Ut ut eros morbi blandit velit. Vel sit ridiculus
                            lectus Lorem ipsum dolor sit amet consectetur. Amet
                            consequat ut dolor quam. Ut ut eros morbi blandit
                            velit. Vel sit ridiculus lectus{" "}
                          </div>
                          <span
                            className="mt-1 text-[14px] font-bold text-[#1295DE] underline underline-offset-2 md:text-[20px]"
                            onClick={(e) => setShowMore((prev) => !prev)}
                          >
                            Show More
                          </span>
                        </div> */}
                      <div className="mt-4 flex w-full flex-col items-center justify-center p-1 md:mt-4 ">
                        <button
                          className=" flex w-full  items-center justify-center gap-2 rounded-2xl border-2 border-[#0077B5] bg-white py-2 px-4 md:w-[30%]"
                          onClick={(e) => {
                            e.stopPropagation();
                            linkedinBadgeAuth();
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faLinkedin}
                            className="text-[#0077B5]"
                            size="2x"
                          />
                          <span className="text-[16px] font-semibold text-[#0077B5] md:text-[18px]">
                            Share On LinkedIn
                          </span>
                        </button>
                      </div>
                    </div>
                    <div
                      onClick={(e) => navigate("/pricing")}
                      className="mt-6 w-full md:mt-10"
                    >
                      <img
                        urlEndpoint="https://img.learntube.ai/public-assets/"
                        src={
                          window.innerWidth > 758
                            ? "https://img.learntube.ai/public-assets/Ai%20notes/Group%2010124-1.webp?updatedAt=1721903193012"
                            : "https://img.learntube.ai/public-assets/Ai%20notes/Group%2010124.webp?updatedAt=1721903193002"
                        }
                        className="cursor-pointer object-fill"
                      />
                    </div>
                  </>
                ) : (
                  <div
                    className="relative flex w-full flex-col items-center justify-center"
                    style={{
                      backgroundImage: `url('https://img.learntube.ai/public-assets/Content_player/Rectangle%205246.png?updatedAt=1694426789883')`,
                      backgroundRepeat: "no-repeat",
                      borderRadius: "18.34px",
                      boxShadow:
                        "0px 1.5283px 4.58491px 0px rgba(0, 0, 0, 0.25)",
                      backgroundPosition: "center",
                      backgroundSize: `${
                        window?.innerWidth < 760 ? "500%" : "200%"
                      }`,
                    }}
                  >
                    <img
                      urlEndpoint="https://img.learntube.ai/public-assets/"
                      src="https://img.learntube.ai/public-assets/Content_player/Idea%20creation%202.gif?updatedAt=1693985318446"
                      className="mt-6 h-[210px] w-[208px]"
                      transformation={[
                        {
                          height: "160",
                          width: "160",
                        },
                      ]}
                    />
                    <div className="mb-6 px-8 py-2 text-[16px] font-semibold text-black md:text-[20px]">
                      Generating Feedback For {first_name}...
                    </div>
                  </div>
                )}
              </div>
              {enableMskillAutoNext &&
                feedbackData?.result === "success" &&
                feedbackData?.data?.user_weak_areas?.length === 0 && (
                  <>
                    {/* changed */}
                    <div className="mt-8 mb-3 flex w-full justify-between">
                      <p className="text-[14px] md:text-[24px] ">
                        Loading next lesson in{" "}
                        <span className="font-semibold">
                          {nextLessonTimer.timer}s
                        </span>
                      </p>
                      <div className="flex">
                        <img
                          urlEndpoint="https://img.learntube.ai/public-assets/"
                          src={
                            "https://img.learntube.ai/public-assets/Content_player/coinImage.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1676614260936"
                          }
                          className=" h-8 w-8"
                          transformation={[
                            {
                              height: "60",
                              width: "60",
                            },
                          ]}
                        />
                        <div className="ml-2 text-[20px] font-semibold text-[#2BBD13] md:text-3xl">
                          +1
                        </div>
                      </div>
                    </div>
                    {/* changed */}
                    <div className="w-full">
                      <Progressbar
                        progress={
                          !isFirstTimeUser
                            ? ((10 - nextLessonTimer.timer) / 10) * 100
                            : ((5 - nextLessonTimer.timer) / 5) * 100
                        }
                      />
                    </div>
                  </>
                )}
              {feedbackData?.result === "success" ? (
                <button
                  className="mt-6 w-[70%] rounded-lg  bg-[#13B284] py-2 px-3 text-white md:w-60"
                  disabled={!nextLesson?.isNextLessonAvailable}
                  onClick={() => navigate(`/${nextLesson?.nextLessonDetails}`)}
                >
                  Go To Next Lesson
                </button>
              ) : (
                <button
                  className="mt-6 w-[70%] rounded-lg border-2 border-[#1CA571]  bg-white py-2 px-3 text-[#1CA571] md:w-60"
                  disabled={!nextLesson?.isNextLessonAvailable}
                  onClick={() => navigate(`/${nextLesson?.nextLessonDetails}`)}
                >
                  Go To Next Lesson
                </button>
              )}
              <br />
              <br />
            </div>
          )
        ) : (
          <MskillComplete
            navigateTo={`/${nextLesson?.nextLessonDetails}`}
            mskill={{ course_slug, skill_slug, mskill_slug }}
            jesData={jesData}
            mskillData={mskillData}
            mSkillProgress={mSkillProgress}
          />
        )
      ) : showScore ? (
        <QuizScoreCard
          quizScoreCardData={getQuizScoreData()}
          customButton={
            mSkillProgress === 100 ? (
              <></>
            ) : (
              <button
                className="mt-3 rounded-lg bg-[#13B284] py-2 px-3 text-white "
                disabled={!nextLesson?.isNextLessonAvailable}
                onClick={() => navigate(`/${nextLesson?.nextLessonDetails}`)}
              >
                Go To Next Lesson
              </button>
            )
          }
        />
      ) : (
        <>
          <div className="-z-1 relative flex w-full items-center justify-center rounded p-4 md:my-1">
            <div className="relative w-full">
              {/* <span className="absolute -top-6 left-1 ml-1 border-x-2 border-t-2  rounded-t-lg px-2">
              Question {currentIndex + 1} of {quiz.length}
              </span> */}
              {mSkillProgress === 0 && (
                <div className="quiz-complete mb-4 flex items-center justify-between rounded-md border-2 border-black px-2 py-3 text-xs md:mx-3 md:mt-0 md:p-2 md:text-base">
                  {!is_activation ? (
                    <p>Complete the quiz to unlock the course for free</p>
                  ) : !betaProductUser?.ninjacurate_is_paid &&
                    !betaProductUser?.certified_is_paid ? (
                    <p>Complete quiz to unlock full access.</p>
                  ) : (
                    <p onClick={(e) => setActivationModal(true)}>
                      Complete quiz to unlock
                      <span className="ml-1 cursor-pointer text-[#13B284] underline">
                        full access & certificate for free
                      </span>
                    </p>
                  )}
                  <div className="pr-1 md:pr-2">
                    <Timer />
                  </div>
                </div>
              )}

              {!is_activation ? (
                skillProgress === 0 &&
                mSkillProgress === 0 &&
                quizNotification && (
                  <div className="relative flex items-center justify-between rounded-md bg-[#FFF1D9] p-3 md:mx-auto md:w-[70%] md:justify-evenly">
                    <img
                      urlEndpoint="https://img.learntube.ai/public-assets/"
                      src="https://img.learntube.ai/public-assets/Content_player/certificateIcon.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1657529938820"
                      className="mr-4 h-6 w-6 md:h-10 md:w-10"
                      transformation={[
                        {
                          height: "360",
                          width: "360",
                        },
                      ]}
                    />

                    <p className="text-sm font-semibold text-[#F59E0B] md:text-lg">
                      Completing quiz is necessary to get a certificate.
                    </p>
                    <FontAwesomeIcon
                      icon={faTimes}
                      className="absolute top-2 right-2 cursor-pointer text-[#F59E0B]"
                      onClick={() => setQuizNotification(false)}
                    />
                  </div>
                )
              ) : (
                <div className="relative flex w-full items-center justify-between   rounded-md bg-[#E9FFF7] p-3 md:justify-evenly">
                  <img
                    urlEndpoint="https://img.learntube.ai/public-assets/"
                    src="https://img.learntube.ai/public-assets/Content_player/Group_7395.svg?updatedAt=1679553770614"
                    className="mr-4 h-6 w-6 md:h-10 md:w-10"
                    transformation={[
                      {
                        height: "360",
                        width: "360",
                      },
                    ]}
                  />
                  <div className="text-sm font-semibold md:text-lg">
                    <span className="text-[#13B284]">446</span> people completed
                    this quiz today in{" "}
                    <span className="text-[#13B284]">less than 5 mins </span>and
                    got certified!
                  </div>
                </div>
              )}

              {/* <br /> */}
              {/* <div className="flex justify-between "> */}
              {/* {mSkillProgress !== 0 && ( */}
              {challengeInfo[0]?.["3day_challenge"] === "live" && (
                <div className="flex w-full items-center justify-between self-center rounded-lg border-2 border-black py-2 px-2 md:px-4">
                  <div className="flex w-full flex-col items-start justify-center">
                    <div className="flex items-center justify-center">
                      <img
                        urlEndpoint="https://img.learntube.ai/public-assets/"
                        src=" https://img.learntube.ai/public-assets/banner/clock.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1672306987202"
                        className="h-6 w-6"
                        transformation={[
                          {
                            height: "60",
                            width: "60",
                          },
                        ]}
                      />
                      <h1 className=" ml-2 text-xs font-semibold  md:text-[14px]">
                        1-Day Challenge In Progress
                      </h1>
                    </div>
                    <div className="flex w-full items-center">
                      <div className="w-[69px]">
                        <ProgressBar
                          bgcolor={"#54D15A"}
                          progress={mSkillProgress}
                          height={8}
                        />
                      </div>
                      <div className="ml-4 mr-2 text-supertiny md:text-[14px]">
                        Complete{" "}
                        {mskillProgressObject?.progress_by_completed
                          ?.totalLessons -
                          mskillProgressObject?.progress_by_completed
                            ?.completedLessons}{" "}
                        more lessons to get{" "}
                        <span className="font-bold">certificate for free</span>
                      </div>
                    </div>
                  </div>
                  <OneDayTimer
                    currentTime={challengeInfo[0]?.challenge_data?.created_at}
                  />
                </div>
              )}
              <div className="my-3 flex w-full items-center justify-between">
                {/* <ProgressSteps
                  quiz={quiz}
                  currentIndex={currentIndex}
                  questionAnswer={questionAnswer}
                ></ProgressSteps> */}
                <p className="mr-2 w-36 text-xs font-semibold text-[#086788] md:text-sm">
                  Question {currentIndex + 1}/3
                </p>
                <div className="w-full">
                  <Progressbar
                    progress={
                      getQuizCompletedPercentage(questionAnswer) * 33.33
                    }
                    progressColor={"#5FDE11"}
                  />
                </div>
                <div className="ml-2 flex items-center justify-between">
                  <FontAwesomeIcon
                    icon={faAngleLeft}
                    size="xl"
                    className="mr-3 cursor-pointer text-teal-600 duration-300 ease-out"
                    onClick={handlePrevChange}
                  />
                  <FontAwesomeIcon
                    icon={faAngleRight}
                    size="xl"
                    className="ml-3 cursor-pointer text-teal-600 duration-300 ease-out"
                    onClick={handleNextChange}
                  />
                </div>
                {/* <div className="flex justify-end w-full">{ToggleBtn()}</div> */}
                {/* <br /> */}
              </div>
              {/* )} */}
              {/* {mSkillProgress !== 0 && <div className="">{ToggleBtn()}</div>} */}
              {/* </div> */}
              <hr className="w-full bg-slate-200" />
              <div className="w-full rounded-xl md:p-2 ">
                {/* quiz question */}
                <div className="pb-3 text-sm font-bold md:px-4 md:pb-3 md:text-base">
                  {quiz[currentIndex]?.quiz_question}
                </div>
                {/* Four quiz radio buttons */}
                <div className="grid grid-cols-1 gap-1 md:grid-cols-2 md:gap-4  ">
                  {quizOptions.map((option, index) => {
                    const greenColor =
                      questionAnswer[currentIndex]?.isAnswered &&
                      questionAnswer[currentIndex]?.selectedOption
                        ?.trim()
                        ?.toLowerCase() ===
                        quiz[currentIndex]["quiz_correctAnswer"]
                          ?.trim()
                          ?.toLowerCase() &&
                      quiz[currentIndex]["quiz_correctAnswer"]
                        ?.trim()
                        ?.toLowerCase() === option?.trim()?.toLowerCase();
                    const redColor =
                      questionAnswer[currentIndex].isAnswered &&
                      !questionAnswer[currentIndex].isCorrect &&
                      option === questionAnswer[currentIndex].selectedOption;
                    return (
                      <div
                        className="rounded-lg bg-[#C6FFF2] text-sm active:animate-ping-quiz md:text-xl"
                        key={index}
                        value={option}
                        onClick={(e) => {
                          handleInputChange(e, index);
                        }}
                      >
                        {/* <label
                  className={`cursor-pointer border-2 rounded-xl block p-1 md:p-1
                    hover:border-blue-500 transition duration-200 ease-in-out

                  ${option === questionAnswer[currentIndex].selectedOption &&
                    questionAnswer[currentIndex].isAnswered &&
                    `border-blue-500`
                    }

                    `}
                > */}
                        <label
                          className={`relative flex h-full w-full cursor-pointer items-center justify-start rounded-lg border-2 px-4 py-2 md:p-3 md:text-lg ${
                            questionAnswer[currentIndex].isAnswered
                              ? greenColor
                                ? "border-[#35CA0F]"
                                : redColor && "border-red-700"
                              : option ===
                                questionAnswer[currentIndex].selectedOption
                              ? "border-blue-500 border-2"
                              : "border-2 border-[#C6FFF2]"
                          } ${
                            !questionAnswer[currentIndex].isAnswered &&
                            `hover:border-blue-500 transition duration-200 ease-in-out`
                          }
                          ${
                            option ===
                              questionAnswer[currentIndex].selectedOption &&
                            !questionAnswer[currentIndex].isAnswered &&
                            `border-blue-500 border-2`
                          }
                        ${
                          greenColor
                            ? "border-2 border-[#35CA0F] bg-[#D6FFCB]"
                            : redColor && "border-2 border-red-700 bg-[#FFCBCB]"
                        }
                        ${
                          questionAnswer[currentIndex].isAnswered &&
                          questionAnswer[currentIndex].isCorrect &&
                          option !==
                            questionAnswer[currentIndex].selectedOption &&
                          "border-2 border-red-700 bg-[#FFCBCB]"
                        }
                    `}
                        >
                          <input
                            type="radio"
                            id={option}
                            name="customRadioInline"
                            className={`form-radio hidden h-5 w-5 ${
                              greenColor
                                ? "text-green-[#35CA0F] checked:bg-green-700"
                                : redColor && "text-red-700 checked:bg-red-700"
                            } `}
                            value={option}
                            // onChange={handleInputChange}
                            disabled={questionAnswer[currentIndex].isCorrect}
                            checked={
                              option ===
                              questionAnswer[currentIndex].selectedOption
                            }
                          />
                          <div
                            className={`mr-3 flex h-6 w-6 items-center justify-center rounded-full border p-1 ${
                              questionAnswer[currentIndex].isAnswered
                                ? greenColor
                                  ? "border-[#35CA0F]"
                                  : redColor && "border-red-700"
                                : "border-[#086788]"
                            }`}
                            style={{ zIndex: 2 }}
                          >
                            <p
                              className={`text-sm font-semibold ${
                                questionAnswer[currentIndex].isAnswered
                                  ? greenColor
                                    ? ""
                                    : redColor && "text-red-700"
                                  : "text-[#086788]"
                              }`}
                              style={{ zIndex: 2 }}
                            >
                              {index === 0
                                ? "A"
                                : index === 1
                                ? "B"
                                : index === 2
                                ? "C"
                                : "D"}
                            </p>
                          </div>
                          <p
                            className="text-sm font-semibold"
                            style={{ zIndex: 3 }}
                          >
                            &nbsp;{option}
                          </p>
                          {questionAnswer[currentIndex].isCorrect && quizPoll && (
                            <div
                              className={`absolute top-0 left-0 flex h-full items-center justify-end rounded-lg opacity-40`}
                              style={{
                                zIndex: 1,
                                backgroundColor: `${
                                  getQuizPollAnalytics(quizPoll).colors[index]
                                }`,
                                width: `${
                                  getQuizPollAnalytics(quizPoll).percentages[
                                    index
                                  ]
                                }%`,
                              }}
                            ></div>
                          )}
                          {questionAnswer[currentIndex].isCorrect && quizPoll && (
                            <p
                              className="absolute right-0 mr-2 text-xs font-semibold"
                              style={{
                                color: `${
                                  getQuizPollAnalytics(quizPoll).colors[index]
                                }`,
                              }}
                            >
                              {Math.ceil(
                                getQuizPollAnalytics(quizPoll).percentages[
                                  index
                                ],
                              )}
                              %
                            </p>
                          )}
                        </label>
                      </div>
                    );
                  })}
                </div>
                <div className="flex justify-between md:flex-row-reverse">
                  <div className="mt-5 mb-2 flex flex-col md:items-end">
                    <div className="flex justify-between md:justify-start">
                      {/* <button
                              ref={submitButtonRef}
                              onClick={questionAnswer[currentIndex].isCorrect ? () => handleNextChange() : () => handleSubmit()}
                              className={`text-xs md:text-md font-semibold px-5 py-2 rounded shadow ${questionAnswer[currentIndex].isCorrect ? 'bg-cn_green text-white' : !questionAnswer[currentIndex].isAnswered ? "bg-[#13B284] text-white" : "bg-[#FDBF48]"} `}
                            >
                                {!questionAnswer[currentIndex].isAnswered
                                  ? (is_activation && currentIndex ===0 &&  questionAnswer[currentIndex]?.selectedOption?.length === 0  )
                                  ? 'Try'  : 'Submit'
                                  : questionAnswer[currentIndex].isCorrect
                                    ? width > 648 ? 'Hurray, Correct Answer!' : 'Correct!'
                                    : 'Oops! Try Again'}
                            </button> */}

                      {currentIndex === quiz.length - 1 && width > 768 && (
                        <button
                          onClick={handleShowScore}
                          type="button"
                          className="md:text-md ml-2 block h-min rounded border bg-orange-400 px-4 py-2 text-xs font-medium leading-tight text-white shadow-md transition duration-150 ease-in-out hover:bg-yellow-400 hover:text-black hover:shadow-lg focus:bg-orange-500 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-orange-800 active:shadow-lg disabled:bg-gray-400"
                          disabled={
                            !(
                              questionAnswer.length === quiz.length &&
                              questionAnswer.every(
                                (question) => question.isCorrect,
                              )
                            )
                          }
                        >
                          View Score
                        </button>
                      )}
                    </div>

                    {!is_activation && (
                      <div
                        className="my-2 -ml-1 flex w-auto cursor-pointer"
                        onClick={() => setQuizReportModal(true)}
                      >
                        <FontAwesomeIcon
                          title={"report this question"}
                          icon={faTriangleExclamation}
                          className={`fa-xs hover:scale-110} mx-1 text-slate-500 md:mx-2`}
                        />
                        <p
                          className={`md:text-md text-[10px] font-semibold text-[#64748B] underline ${
                            currentIndex === quiz.length - 1
                              ? ""
                              : "whitespace-nowrap"
                          }`}
                        >
                          Report this question
                        </p>
                      </div>
                    )}
                    {is_activation && width > 768 ? (
                      <div className="mt-1 flex w-full text-xs font-medium italic  text-black opacity-[74%] md:w-auto lg:justify-end">
                        You get multiple attempts :)
                      </div>
                    ) : null}
                  </div>

                  {creator?.[0]?.is_featured && (
                    <ContentCreator creator={creator} />
                  )}
                </div>
                {is_activation && width < 768 ? (
                  <div className="mt-1 flex w-full text-xs font-medium italic  text-black opacity-[74%] md:w-auto lg:justify-end">
                    You get multiple attempts :)
                  </div>
                ) : null}
              </div>
            </div>
          </div>
          {showQuizPoll && quizPoll && (
            <>
              <h2 className="mt-4 text-xl font-semibold">What People Choose</h2>
              <Bar options={options} data={data} />
              {/* {mainRef?.current.scrollTo({
            top: mainRef?.current?.scrollHeight,
            behavior: 'smooth',
          })} */}
            </>
          )}
        </>
      )}

      <QuizPopup
        openModal={successPopup}
        setOpenModal={setSuccessPopup}
        heading={"Quiz Completed"}
        text={"Congrats! You did it."}
        coinAmount={3}
      />
      <ReportQuizModal
        openReportModal={quizReportModal}
        setOpenReportModal={setQuizReportModal}
        quizDetails={quiz}
        currentQuizIndex={currentIndex}
      />

      <ActivationModal
        isModalEnabled={activationModal}
        setIsModalEnabled={setActivationModal}
      />
    </div>
  );
};

export default React.memo(Quiz);
